








import { defineComponent, onMounted } from '@vue/composition-api'

export default defineComponent({
  props: {
    text: { type: String, default: '' },
    bc: { type: String, default: 'normal' },
    sound: { type: String, default: '' },
  },
  setup(props, context) {
    const music = new Audio()
    music.volume = 0.2
    onMounted(() => {
      if (props.sound === 'next') {
        music.src = './sound/next_sound.mp3'
      }
      if (props.sound === 'before') {
        music.src = './sound/before_sound.mp3'
      }
      if (props.sound === 'reset') {
        music.src = './sound/reset_sound.mp3'
      }
      if (props.sound === 'other') {
        music.src = './sound/other_sound.mp3'
      }
      music.load()
    })
    const onClick = () => {
      context.emit('click')
      music.play()
    }
    return {
      onClick,
    }
  },
})
